// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3X9Mn","buttons":"RemoveExpirationActionButtons_buttons__19Xxe"};